import L from "leaflet";

export const pinIcon = (index, { active = false, draft = false } = {}) =>
  L.divIcon({
    className: "",
    html: `<div class="map-pin ${active ? "pin-active" : ""} ${draft ? "pin-draft" : ""}"><span>${index ?? ""}</span></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

export function haversineKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}

export function formatDistance(km) {
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km.toFixed(1)} km`;
}
